import * as dataActions from '../../actions/dataActions';
import * as legendActions from '../../actions/legendActions';
import * as chartActionTypes from '../../constants/chart-action-types';
import * as utils from './data.utils';

const initialState = {
  dataPanelType: 'data',
  firstRowAsNames: false,
  firstColumnAsCategories: false,
  // google sheets
  sheetsUrl: '',
  sheetsLastUpdated: '',
  sheetsError: '',
  sheetName: { id: null, name: null },
  sheetNames: [],
  firstCell: '',
  lastCell: '',
  // For non-date categories:
  removeOverlappingCategories: true,
  allowCategoriesLinebreak: true,
  // date time
  categoriesAreDates: false,
  categoriesAreMonthly: false,
  fiscalYears: false,
  irregularDates: false,
  reverseDateMonth: false,
  // notes & references
  dataSource: '',
  spreadLink: '',
  dataNotes: '',
  logScaleAllowed: true,
  mustRender: false,
};

function dataReducer(state = initialState, action) {
  const { payload, stateTree } = action;

  switch (action.type) {
    case chartActionTypes.DESTROY_CHART:
      return initialState;
    case legendActions.MUST_RENDER_FALSE:
      return { ...state, mustRender: payload };
    case chartActionTypes.RECEIVE_CHART:
      return utils.fetchChartData(state, action);
    case dataActions.UPDATE_FIRST_ROW_AS_NAMES:
      return utils.updateData(stateTree, state, payload, 'firstRowAsNames');
    case dataActions.UPDATE_FIRST_COLUMN_AS_CATEGORIES:
      return utils.updateData(stateTree, state, payload, 'firstColumnAsCategories');
    case dataActions.UPDATE_REMOVE_OVERLAPPING_CATEGORIES:
      return utils.updateData(stateTree, state, payload, 'removeOverlappingCategories');
    case dataActions.UPDATE_ALLOW_CATEGORIES_LINE_BREAK:
      return utils.updateData(stateTree, state, payload, 'allowCategoriesLinebreak');
    case dataActions.UPDATE_CATEGORIES_ARE_DATES:
      return utils.updateData(stateTree, state, payload, 'categoriesAreDates');
    case dataActions.UPDATE_CATEGORIES_ARE_MONTHLY:
      return utils.updateData(stateTree, state, payload, 'categoriesAreMonthly');
    case dataActions.UPDATE_FISCAL_YEARS:
      return utils.updateData(stateTree, state, payload, 'fiscalYears');
    case dataActions.UPDATE_IRREGULAR_DATES:
      return utils.updateData(stateTree, state, payload, 'irregularDates');
    case dataActions.UPDATE_REVERSE_DATE_MONTH:
      return utils.updateData(stateTree, state, payload, 'reverseDateMonth');
    case dataActions.UPDATE_DATA_SOURCE:
      return utils.updateData(stateTree, state, payload, 'dataSource');
    case dataActions.UPDATE_SPREAD_LINK:
      return utils.updateData(stateTree, state, payload, 'spreadLink');
    case dataActions.UPDATE_DATA_NOTES:
      return utils.updateData(stateTree, state, payload, 'dataNotes');
    case dataActions.UPDATE_DATA_PANEL_TYPE:
      return utils.updateData(stateTree, state, payload, 'dataPanelType');
    case dataActions.UPDATE_SHEETS_URL:
      return utils.updateData(stateTree, state, payload, 'sheetsUrl');
    case dataActions.UPDATE_SHEETS_LAST_UPDATED:
      return utils.updateData(stateTree, state, payload, 'sheetsLastUpdated');
    case dataActions.UPDATE_SHEETS_ERROR:
      return utils.updateData(stateTree, state, payload, 'sheetsError');
    case dataActions.UPDATE_SHEET_NAME:
      return utils.updateData(stateTree, state, payload, 'sheetName');
    case dataActions.UPDATE_SHEET_NAMES:
      return utils.updateData(stateTree, state, payload, 'sheetNames');
    case dataActions.UPDATE_FIRST_CELL:
      return utils.updateData(stateTree, state, payload, 'firstCell');
    case dataActions.UPDATE_LAST_CELL:
      return utils.updateData(stateTree, state, payload, 'lastCell');
    case dataActions.UPDATE_LOG_SCALE_ALLOWED:
      return utils.updateData(stateTree, state, payload, 'logScaleAllowed');
    default:
      return state;
  }
}

export default dataReducer;
